import { axiosInstance } from 'api';

export const axiosBaseQuery =
  () =>
  async ({ url, method = 'get', data, params, skipErrorModal }) => {
    try {
      const response = await axiosInstance({ url, method, data, params, skipErrorModal });
      return { data: response.data };
    } catch (error) {
      return { error: { status: error?.status ?? 'CUSTOM_ERROR', data: error } };
    }
  };
